import {type PIXI} from '@colonist/pixi'
import {type UIGameManager} from '../UIGameManager.ts'
import {UIGameSpriteHandler} from '../../UIGameSpriteHandler.ts'
import {UIHoverActionController} from './UIHoverActionController.ts'
import {PieceTypes} from '@colonist/game-base-types'
import {getCardsForPiece} from '@colonist/game-card-types'
import {MechanicValidatorCityWall} from '@colonist/game-mechanic-validators'
import {type MechanicCityWallState} from '@colonist/game-states'

export class UICityWallHoverActionController extends UIHoverActionController {
    private readonly validatorCityWall: MechanicValidatorCityWall

    constructor(uiGameManager: UIGameManager, cityWallState: MechanicCityWallState) {
        super(uiGameManager)
        this.validatorCityWall = new MechanicValidatorCityWall(this.uiGameManager.gameController.getPlayerValidators(), this.uiGameManager.gameController.mapValidator, cityWallState)
        this.isCornerAction = true
        this.resources = getCardsForPiece(PieceTypes.CityWall)
        this.action = (index: number) => this.uiGameManager.socketGameSend.confirmBuildCityWallSkippingSelection(index)
        this.uiGameManager.mapController.hoverController.registerTileCornerHoverAction(this)
    }

    getBankActionAmount(index: number): number {
        const cityWallPlayerState = this.validatorCityWall.getCityWallPlayerState(this.uiGameManager.gameController.myColor)
        return cityWallPlayerState.bankCityWallAmount
    }

    protected updateState() {
        const player = this.uiGameManager.gameController.getPlayerState(this.uiGameManager.gameController.myColor)
        const canPlaceCityWall = this.validatorCityWall.canPlayerPlaceCityWall(player.color)
        this.updateHoverLocations(canPlaceCityWall.validHoverLocations, canPlaceCityWall.canTakeAction)
        this.uiGameManager.mapController.hoverController.onHoverStateChange()
    }

    getTexture(index: number): PIXI.Texture {
        return UIGameSpriteHandler.getCityWallForPlayer(this.uiGameManager.gameController.myColor)
    }
}
